import { QueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { TFunction } from 'i18next';
import { enqueueSnackbar } from 'notistack';
import { FormEvacZoneStatus } from 'shared/types';
import { getErrorsListFromServerResponse } from 'shared/utils';

export const handlePendingReviewZonesErrorOrFallback = async (input: {
  error: AxiosError;
  queryClient: QueryClient;
  t: TFunction;
  currentZonesWithStatus: FormEvacZoneStatus[];
  updateFormZones: (zonesWithStatus: FormEvacZoneStatus[]) => void;
  geoEventId?: number;
  fallbackAction?: () => void;
}): Promise<void> => {
  const {
    error,
    queryClient,
    t,
    currentZonesWithStatus,
    updateFormZones,
    geoEventId,
    fallbackAction,
  } = input;

  const errors = error?.response?.data;
  const errorMessages = getErrorsListFromServerResponse(errors);

  const isPendingReviewError = errorMessages.some((msg) =>
    msg.toLowerCase().includes('pending review'),
  );
  const isInactiveError = errorMessages.some((msg) =>
    msg.toLowerCase().includes('is inactive'),
  );

  if (isPendingReviewError || isInactiveError) {
    await queryClient.invalidateQueries({
      queryKey: ['evacuation-zones', geoEventId],
    });

    if (isInactiveError) {
      const inactiveZonesUidV2s = errorMessages
        .filter((msg) => msg.toLowerCase().includes('is inactive'))
        .map((msg) => msg.split('is inactive')[0].trim());

      const filteredZonesWithStatus = currentZonesWithStatus.filter(
        (zone) => !inactiveZonesUidV2s.includes(zone.evacZone.uidV2),
      );

      updateFormZones(filteredZonesWithStatus);
    }

    enqueueSnackbar(t('pendingEvacZonesWarning.error.newZones'), {
      variant: 'error',
    });

    return;
  }

  fallbackAction?.();
};
